import { Form as _Form } from "@byte-design/ui/es/components/form";
import { Switch as _Switch } from "@byte-design/ui/es/components/switch";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var SwitchWrap = function SwitchWrap(_ref) {
  var value = _ref.value,
      props = _objectWithoutProperties(_ref, ["value"]);

  return React.createElement(_Switch, Object.assign({
    checked: value
  }, props));
};

export var FieldSwitch = _Form.withField(SwitchWrap, false, {
  displayName: 'FieldSwitch',
  useInputRef: false,
  useDomRef: false
});